import { render, staticRenderFns } from "./popover-icon.vue?vue&type=template&id=3567e312&"
import script from "./popover-icon.vue?vue&type=script&lang=js&"
export * from "./popover-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports